<div fxLayout="column" fxFlex="grow">

    <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center">
        <mat-icon (click)="back()">arrow_back</mat-icon>
        <label style="font-weight: 700; font-size: 16px; margin-left: 15px;">
            {{selectedChild.firstName}} {{selectedChild.lastName}}
        </label>
    </div>


    <div fxLayout="row wrap" fxFlex="grow" style="margin-top: 20px;">

        <div fxLayout="column" fxFlex="grow" *ngFor="let record of getRecords()" class="card-record-info mat-elevation-z8">

            <div fxLayout="row" fxFlex="grow">

                <div fxLayout="column" fxFlex="85" style="padding: 15px;">

                    <div fxLayout="row">
                        {{record.title}}
                    </div>
                    <div fxLayout="row">
                        {{record.subTitle}}
                    </div>

                </div>

                <div fxLayout="column" fxFlex="15" style="background: var(--secondaryBlue);">

                    <div (click)="showConsent(selectedChild, record)" fxLayout="row" fxFlex="grow" fxLayoutAlign="center center center" style="border:1px solid var(--secondaryBlue); border-top-right-radius: 5px; border-bottom-right-radius: 5px;">
                        <mat-icon style="color: white;">visibility</mat-icon>
                    </div>

                </div>

            </div>

        </div>

    </div>

</div>